import React from 'react'
import {LogoContainer, LogoMark} from './styles'

import Logo from '../../assets/ic_logo-horizontal.png'

export default ({ color }) => (
  <LogoContainer>
    <LogoMark src={Logo} />
  </LogoContainer>
);
